export const subscription = {
  subscriptions: 'Pretplate',
  plan: 'Plan',
  whatsappPlan: 'WhatsApp Plan',
  addOns: 'Dodaci',
  billingDetails: 'Detalji naplate',
  invoices: 'Računi',
  wa1Reminder: 'WA 1. podsjetnik',
  wa2Reminder: 'WA 2. podsjetnik',
  waRenewApi: 'WA Obnovi API',
  waCheckUsageApi: 'WA Provjeri upotrebu API-a',
  waResetUsageApi: 'WA Resetiraj upotrebu API-a',
  waExceedUsageApi: 'WA Prekorači upotrebu API-a',
  waGetBotsInThisAccount: 'WA Dohvati botove u ovom računu',
  appTooltip: {
    TOOLTIP_PLAN_HEADING: 'Imamo najpovoljnije cijene za sve vaše potrebe.',
    TOOLTIP_WHATSAPP_PLAN_HEADING: 'WhatsApp plan',
    TOOLTIP_ADDS_ON_HEADING: 'Kupite dodatne pakete poruka i bijeli etiketirani bot',
    TOOLTIP_ADDS_ON_MESSAGE: 'Ako ste dostigli mjesečno ograničenje poruka, možete kupiti dodatne pakete.',
    TOOLTIP_SUBSCRIPTION_HEADING: 'Provjerite detalje vaše trenutne pretplate',
    TOOLTIP_HORIZONTAL_BAR: 'Provjerite naše mjesečne ili godišnje cijene od 3.000 do 500.000 poruka pomicanjem trake lijevo-desno.',
    TOOLTIP_BILLING_ADDRESS_HEADING: 'Ažurirajte svoje podatke za naplatu za izdavanje računa.',
    TOOLTIP_INVOICES_HEADING: 'Provjerite svoje prethodne račune.',
    TOOLTIP_INVOICES_ACTION: 'Kliknite da biste primili račun na svoj email račun.'
},
currentPlan: {
  seeHowToUse: 'Vidi kako koristiti',
  help: 'Pomoć',
  downgradeRequest1: 'Podnijeli ste zahtjev za smanjenje vašeg plana na',
  downgradeRequest2: 'poruka. Imajte na umu da će vaš plan biti smanjen do kraja trenutnog obračunskog ciklusa',
  downgradeRequest3: 'Možete uživati u',
  downgradeRequest4: 'uslugama do tada.',
  downgradeRequestMaster1: 'Podnijeli ste zahtjev za smanjenje vašeg ',
  downgradeRequestMaster2: ' plana na',
  downgradeRequestMaster3: ' razgovora. Imajte na umu da će vaš plan biti smanjen do kraja trenutnog obračunskog ciklusa',
  downgradeRequestMaster4: 'Možete uživati u',
  downgradeRequestMaster5: 'uslugama do tada.',
  active: 'Aktivan',
  inactive: 'Neaktivan',
  month: 'mjesec',
  year: 'godina',
  messagePack: 'Paket poruka',
  king: 'King',
  baby: 'Baby',
  whatsapp: 'WhatsApp',
  youAreOn: 'Vi ste na',
  plan: 'planu',
  totalMessagesLimit: 'Ukupno ograničenje poruka',
  liveAgentLimit: 'Ograničenje za live agente',
  perMonth: '/mjesec',
  agents: 'agent(a)',
  messagesAddOn: 'Dodatne poruke',
  botWhitelabels: 'Whitelabel botovi',
  totalAddOnMessages: 'Ukupno dodatnih poruka',
  basePrice: 'Osnovna cijena',
  gst: 'GST',
  totalPrice: 'Ukupna cijena',
  totalAddOnPrice: 'Ukupna cijena dodataka',
  whitelabelPrice: 'Cijena Whitelabela',
  startedOn: 'Počelo',
  nextDueOn: 'Sljedeće dospijeće',
  addOnExpiry: 'Istek dodatka',
  website: 'Web stranica',
  facebook: 'Facebook',
  telegram: 'Telegram',
},
invoice: {
    invoiceNumber: 'Broj fakture',
    date: 'Datum',
    invoiceAmount: 'Iznos fakture',
    planAmount: 'Iznos plana',
    plan: 'Plan',
    messages: 'Poruke',
    action: 'Akcija',
    nA: 'N/A',
    appTooltip: {
        clickToReceiveInvoiceInYourEmailAccount: 'Kliknite da biste primili fakturu na svoj email račun',
        clickToDownloadInvoice: 'Kliknite da biste preuzeli fakturu u PDF formatu',
    }
},
messageAddOn: {
  validity: 'Važnost',
  kingPlanHeader: '👑 King Plan',
  youAreOnThe: 'Vi ste na ',
  asOfNowAndWillGet: 'trenutno, i dobićete ',
  messages: 'poruke ',
  inThisPlan: 'u ovom planu. ',
  youCanBuyAdditionalMessaes: 'Možete kupiti dodatne poruke prema potrebama svog poslovanja.',
  plan: ' Plan',
  baby: 'Baby',
  king: 'King',
  get: 'Dobijte ',
  babyPlan: 'Baby Plan ',
  upgradePlan: 'Nadogradnja plana',
  asOfNow: ' trenutno.',
  pleaseUpgradeToKingPlan: 'Molimo nadogradite se na ',
  toEnableAddOnsAndWhitelabelPacks: ' kako biste omogućili dodatke i pakete sa belom etiketom.',
  messageAddOnPacks: 'Paketi za dodavanje poruka',
  ifYouHaveReachedYourMonthlyMessageLimit: `Ako ste dostigli svoj mesečni limit poruka, kupite dodatne pakete i uživajte u neprekidnim uslugama.`,
  pleaseSelectNumberOfExpectedMessages: 'Izaberite broj očekivanih poruka',
  addOnsValidity: 'Važnost dodataka',
  currentBillingCycle: 'Trenutni obračunski ciklus',
  oneYear: 'Jedna godina',
  summary: 'Sažetak',
  messageCreditsWithKingPlan: 'krediti za poruke sa King planom',
  messageCreditsWith: 'krediti za poruke sa ',
  withPlan: '',
  billingCycle: 'Obračunski ciklus',
  payableAmount: 'Iznos za plaćanje ',
  oneTimePayment: 'Jednokratno plaćanje',
  plusTaxes: ' + Porezi',
  buyNow: 'Kupi sada',
  whiteLabelChatWindow: 'Prozor za chat sa belom etiketom',
  noBotsLeftToWhiteLabel: 'Nema preostalih robota za belu etiketu.',
  pleaseSelectTheBotsYouWantToWhiteLabel: 'Odaberite robote koje želite da označite belom etiketom.',
  selectBots: 'Odaberite robote',
  bot: 'Bot',
  bots: 'Bots',
  toBeWhiteLabelled: ' da bude označen belom etiketom',
  remove: 'Ukloni ',
  brandNameFromChatWindow: ' ime brenda iz prozora za chat.',
  willBeValidTill: 'Biće važeće do ',
  ourYearlyPrice: 'Naša godišnja cena ',
  directWhiteLabel: 'Direktna bela etiketa',
  whiteLabelledBots: 'Roboti sa belom etiketom',
  nextRenewalColon: 'Sledeće obnavljanje: ',
  optOutRequested: 'Zahtev za odjavu',
  contactAgency: 'Kontaktirajte agenciju',
  optOut: 'Odjava',
  removeWhiteLabel: 'Ukloni belu etiketu',
  messageCount: 'Poruke',
  numberOfPacks: 'Br. paketa',
  amount: 'Iznos',
  taxes: 'Porezi',
  totalAmount: 'Ukupan iznos',
  numOfBots: 'Br. robota',
  select: 'Odaberi',
  selectTheValidity: 'Odaberite važnost',
},
  payment: {
  },
  paymentMethod: {
    paymentDetails: 'Detalji plaćanja',
    cardNumber: 'Broj kartice',
    cvv: 'CVV',
    month: 'Mesec',
    year: 'Godina',
    save: 'Sačuvaj',
    add: 'Dodaj',
    edit: 'Izmeni',
    disclaimer: 'Napomena: ',
    disclaimerDescription1: 'Gore navedeni detalji plaćanja važe samo za korisnike van Indije.',
    disclaimerDescription2: 'Ne čuvamo podatke vaše kartice kod nas.' +
      'U slučaju da želite promeniti podatke svoje kartice, promeniće se direktno kod gateway za plaćanja.',
    billingAddress: 'Adresa za naplatu',
    companyName: 'Ime kompanije',
    country: 'Zemlja',
    selectCountry: 'Odaberite zemlju',
    stateOrRegion: 'Država/Region',
    streetAddress: 'Ulica i broj',
    gstIn: 'GSTIN',
    postalCode: 'Poštanski broj',
    cancel: 'Otkaži',
    proceedToPay: 'Nastavi sa plaćanjem',
    company: 'Kompanija',
    state: 'Država',
    masterCard: 'Master Card',
    yourCompanyName: 'Ime vaše kompanije',
    yourCountry: 'Vaša zemlja',
    yourRegion: 'Vaša država/region',
    yourPostalCode: 'Vaš poštanski broj',
    plusTaxes: ' + porezi',
    dropDown: {
      month: 'Mesec *',
      year: 'Godina *',
    },
    placeholders: {
      enterCardNumber: 'Unesite broj kartice',
      cvv: 'CVV',
      enterYourCompanyName: 'Unesite ime vaše kompanije',
      enterYourStateOrRegion: 'Unesite vašu državu/region',
      enterYourStreetAddress: 'Unesite vašu ulicu i broj',
      enterYourGSTIN: 'Unesite vaš GSTIN',
      enterPostalCode: 'Unesite poštanski broj',
    }
  },
  plans: {
    viewDetailedPricing: 'Pogledaj detaljne cijene',
    seeHowToUse: 'Pogledaj kako koristiti',
    help: 'Pomoć',
    weHaveGotAPricingPlanPerfectForYou: `Imamo cjenovni plan koji je savršen za tebe`,
    weBelieve: 'Vjerujemo ',
    shouldBeAccessibleToAllCompanies: ' trebalo bi biti dostupno svim tvrtkama, bez obzira na veličinu.',
    monthly: 'Mjesečno',
    yearly: 'Godišnje',
    twoMonthsFree: '(2 mjeseca BESPLATNO)',
    babyPlan: 'Baby Plan',
    freeForever: 'BESPLATNO zauvijek',
    messagesPerMonth: 'Poruke mjesečno',
    currentPlan: 'Trenutni plan',
    freePlan: 'BESPLATNI plan',
    kingPlan: 'King Plan',
    perYear: 'godišnje',
    plan: 'plan',
    toThe: ' do',
    plusTaxes: ' + Porezi',
    perMonth: 'mjesečno',
    upgradePlan: 'Nadogradnja plana',
    changePlan: 'Promijeni plan',
    currentlyActive: 'Trenutno aktivno',
    emperorPlan: 'Emperor Plan (Poduzeće)',
    sendAsManyMessagesAsYouWant: 'Šalji koliko god želiš poruka',
    contactUs: 'Kontaktiraj nas',
    features: 'Značajke',
    areYouSureYouWantToShiftFrom: 'Jesi li siguran/sigurna da želiš preći s',
    messages: 'Poruke',
    planQuestionMark: ' plana?',
    downgradeToFreePlan: 'Povratak na BESPLATNI plan',
    goToBabyPlan: 'Idi na Baby Plan',
    thankYouForChoosingBotPenguin: 'Hvala što si odabrao/odabrala BotPenguin',
    bots: 'Botovi',
    facebookPages: 'Facebook stranice',
    teamMember: 'Član tima',
    dataStorage: 'Pohrana podataka',
    conditionalFlow: 'Uvjetni tok',
    liveChat: 'Uživo chat',
    bookAppointments: 'Zakazivanje termina',
    csvExport: 'CSV izvoz',
    emailAndCallSupport: 'Podrška putem e-pošte i poziva',
    googleCalendarIntegrations: 'Integracija s Google kalendarom',
    zohoCrmIntegrations: 'Integracija s Zoho CRM-om',
    reportsAndAnalytics: 'Izvješća i analitika',
    removeBotPenguinBranding: 'Ukloni BotPenguin oznaku',
    oneBot: '1 Bot',
    twoKMessagesPerMonth: '2k poruka/mjesečno',
    oneFacebookPage: '1 Facebook stranica',
    oneTeamMember: '1 član tima',
    thirtyDaysOfDataStorage: '30 dana pohrane podataka',
    unlimitedBot: 'Neograničen broj botova',
    threeTo500kMessagesPerMonth: '3k do 500k poruka/mjesečno',
    tenFacebookPages: '10 Facebook stranica',
    threeTeamMembers: '3 člana tima',
    nintyDaysOfDataStorage: '90 dana pohrane podataka',
    unlimitedMessages: 'Neograničen broj poruka',
    unlimitedFacebookPages: 'Neograničen broj Facebook stranica',
    unlimitedTeamMembers: 'Neograničen broj članova tima',
    unlimitedDataStorage: 'Neograničena pohrana podataka',
    youAreHere: `Ti si ovdje!`,
    detailedPricing: {
      kingsplan: 'Kraljevski Plan',
      elementary: 'Osnovni',
      solutionType: 'Tip rješenja',
      saas: 'SaaS',
      fbpage1fb: '1 Facebook stranica',
      perMonth100: '100 mjesečno',
      enterprise: 'Poduzeće',
      saasOnPremises: 'SaaS On Premises',
      aiChatbotFeatures: 'Značajke AI Chatbota',
      dataSourceForTraning: 'Izvor podataka za obuku',
      smartFeatures: 'Pametne značajke',
      liveChat: 'Live Chat',
      day30: '30 dana',
      day90: '90 dana',
      landSquared: 'LandSquared',
      doItYourself: 'Napravi sam',
      unifiedInbox: 'Jedinstveni Inbox',
      platforms: 'Platforme',
      websiteChatbot: 'Chatbot za web stranice',
      FacebookMessengerChatbot: 'Facebook Messenger Chatbot',
      Telegram: 'Telegram',
      conversationalLandingPage: 'Razgovorna stranica',
      integrations: 'Integracije',
      reportsAndAnalytics: 'Izvještaji i analize',
      customerSupport: 'Korisnička podrška',
      security: 'Sigurnost',
      bots: 'Botovi',
      babyPlan: 'Baby Plan',
      kingPlan: 'King Plan',
      emperorPlan: 'Emperor Plan',
      noofBots: 'Broj botova',
      one: '1 (Jedan)',
      unlimitedBots: 'Neograničeno botova',
      noOfWebsite: 'Broj web stranica',
      unlimitedWebsites: 'Neograničeno web stranica',
      unlimitedMessages: 'Neograničeno poruka',
      messagesSend: 'Poruka poslano',
      perMonth2000: '2.000 mjesečno',
      upto500000perMonth: 'Do 500.000 mjesečno',
      facebookMessenger: 'Facebook Messenger',
      unlimitedPages: 'Neograničeno stranica',
      telegramNumbers: 'Telegram brojevi',
      unlimited: 'Neograničeno',
      whatsappNumbers: 'WhatsApp brojevi',
      subscribersLeads: 'Pretplatnici / Leadovi',
      createSupportTeam: 'Stvaranje tima za podršku uživo',
      oneMember: '1 Član',
      threeMembers: '3 člana',
      conversationHistory: 'Povijest razgovora',
      thirtyDays: '30 dana',
      ninetyDays: '90 dana',
      chatbotDesigning: 'Dizajniranje Chatbota',
      weAreHereToHelp: 'Tu smo da pomognemo',
      weTakeCareEndToEnd: 'Brinemo se od početka do kraja',
      multipleLanguages: 'Više jezika',
      conditionalFlow: 'Uvjetni tok',
      removeBotPenguinBranding: 'Uklonite BotPenguin Branding',
      gptMessages: 'GPT Poruke',
      aiChatbot: 'AI Chatbot',
      chatGPTIntegration: 'ChatGPT Integracija',
      configureAIChatbotPersonality: 'Konfigurirajte osobnost AI Chatbota',
      trainChatbotOnYourOwnData: 'Obučite Chatbot s vlastitim podacima',
      trainChatbotOnWebPages: 'Obučite Chatbot na web stranicama',
      trainChatbotOnMultipleFiles: 'Obučite Chatbot na više datoteka',
      trainChatbotOnFAQs: 'Obučite Chatbot na FAQ-ovima',
      dataTrainingStorage: 'Pohrana podataka o obuci',
      useChatGPTModel4_3_5Turbo: 'Koristite ChatGPT Model 4/3.5 turbo',
      uploadMultipleFilesForChatbotTraining: 'Prijenos više datoteka za obuku chatbota',
      naturalLanguageProcessing: 'Obrada prirodnog jezika',
      naturalLanguageUnderstanding: 'Razumijevanje prirodnog jezika',
      answerLength: 'Dužina odgovora',
      chatTone: 'Tona razgovora',
      multiLanguage: 'Višejezično',
      answerFormatting: 'Formatiranje odgovora',
      customPrompt: 'Prilagođeni poziv',
      integrateBotPenguinLLM: 'Integrirajte BotPenguin LLM',
      integrateOwnCustomLLM: 'Integrirajte vlastiti/prilagođeni LLM',
      periodicallySyncDataSources: 'Periodična sinkronizacija izvora podataka',
      aiBasedSuggestedQuestions: 'AI bazirana predložena pitanja',
      chooseVisibilityForParticularWebpageSitemap: 'Odaberite vidljivost za određenu web stranicu / sitemap',
      chooseKnowledgeMix: 'Odaberite mješavinu znanja:\nVaša baza znanja\nChatGPT znanje\n"ChatGPT znanje + Vaša baza znanja"',
      faqExtractionFromFileAndURL: 'Izvlačenje FAQ-a iz datoteke i URL-a',
      analyticsToImproveAI: 'Analitika za poboljšanje AI',
      exportQuestionFlow: 'Izvoz tijeka pitanja',
      sessionManagement: 'Upravljanje sesijama',
      collectFeedbackOnChatbotResponses: 'Sakupljanje povratnih informacija o odgovorima chatbota',
      smartAIFollowUpQuestions: 'Pametna / AI pitanja za praćenje',
      trainOnYourNotionWorkspaceData: 'Obučite se na podacima vašeg Notion workspacea',
      trainOnYoutubeVideo: 'Obučite se na YouTube videozapisima',
      trainOnCustomVideoUpload: 'Obučite se na vlastitim videozapisima',
      rssFeed: 'RSS Feed',
      googleDrive: 'Google Drive',
      dropBox: 'DropBox',
      ipAndRegionBlocking: 'Blokiranje IP adrese i regije',
      emailAndMobileValidation: 'Validacija e-pošte i mobilnih uređaja',
      appointmentsBooking: 'Rezervacija termina',
      humanHandover: 'Prijenos čovjeka',
      botHandover: 'Prijenos bota',
      handoverBetweenAgents: 'Prijenos između agenata',
      mobileAppsForAgents: 'Mobilne aplikacije za agente',
      roleBasedAccessControls: 'Kontrole pristupa temeljene na ulozi',
      apiIntegrationOnChatFlows: 'API integracija na tokovima razgovora',
      liveChatWidget: 'Widget za razgovor uživo',
      typingIndicator: 'Indikator pisanja',
      liveVisitorsDetails: 'Detalji o posjetiteljima uživo',
      multipleSimultaneousChat: 'Višestruki simultani razgovor',
      liveTypingView: 'Prikaz pisanja uživo',
      ruleBasedChatRouting: 'Razgovor na temelju pravila',
      chatAutoAssignments: 'Automatsko dodjeljivanje razgovora',
      efficientOmnichannelInterface: 'Učinkovito omnichannel sučelje',
      quickReplies: 'Brzi odgovori',
      unifiedCustomerProfile: 'Jedinstveni profil korisnika',
      visitorStats: 'Statistike posjetitelja',
      addContactsFromWhatsapp: 'Dodaj kontakte iz WhatsApp-a',
      applyFilterAndSortConversations: 'Primijenite filtre i sortirajte razgovore',
      seeChatLogs: 'Pogledajte zapisnike razgovora',
      assignNotesAndChatTags: 'Dodijelite bilješke i oznake razgovora',
      directCallsToLeadsWithTwilio: 'Izravni pozivi do voditelja s Twilio-om',
      customerSegmentation: 'Segmentacija korisnika',
      exportLeadsInCSV: 'Izvoz voditelja u CSV',
      leadNotificationsByEmail: 'Obavijesti o voditeljima putem e-pošte',
      website: 'Web stranica',
      wordPress: 'WordPress',
      whatsApp: 'WhatsApp',
      facebook: 'Facebook',
      telegram: 'Telegram',
      shopify: 'Shopify',
      autoTriggeringOnMobileDesktop: 'Automatsko pokretanje na mobilnim uređajima/računalima',
      hideBotOnSpecificPages: 'Sakrijte bota na određenim stranicama',
      imageSharing: 'Dijeljenje slika',
      readyToUseChatFlowTemplates: 'Gotovi predlošci za tijek razgovora',
      fileSharing: 'Dijeljenje datoteka',
      customDesignForChatWindow: 'Prilagođeni dizajn za prozor razgovora',
      facebookMessengerBot: 'Facebook Messenger Bot',
      facebookSubheading: 'Facebook podnaslov',
      telegramSubheading: 'Telegram podnaslov',
      conversationalLangdingPageSubheading: 'Podnaslov razgovorne landing stranice',
      integrationsSubheading: 'Podnaslov integracija',
      multipleSmartFlows: 'Višestruki pametni tokovi',
      dripCampaigns: 'Kapajuće kampanje',
      broadcastFBMessages: 'Slanje FB poruka',
      multipleFacebookBotWidgets: 'Višestruki Facebook bot widgeti',
      facebookAutoReplyOnComments: 'Automatski odgovor na komentare na Facebooku',
      facebookECommerce: 'Facebook E-trgovina',
      broadcastAnalytics: 'Analitika slanja',
      telegramMessengerBot: 'Telegram Messenger Bot',
      readyToUseTemplates: 'Gotovi predlošci',
      groupBroadcastTelegramMessages: 'Grupno slanje Telegram poruka',
      multipleTelegramBotWidgets: 'Višestruki Telegram bot widgeti',
      conversationalLandingPageBot: 'Bot za razgovornu landing stranicu',
      smartReplies: 'Pametni odgovori',
      interactiveAndCustomizableUI: 'Interaktivno i prilagodljivo korisničko sučelje',
      leadManagement: 'Upravljanje voditeljima',
      easyToInstallAndShare: 'Lako za instalaciju i dijeljenje',
      agileCRM: 'Agile CRM',
      capsule: 'Capsule',
      insightly: 'Insightly',
      nimble: 'Nimble',
      leadsquared: 'LeadSquared',
      chakra: 'Chakra',
      plivo: 'Plivo',
      helpcrunch: 'HelpCrunch',
      getresponse: 'GetResponse',
      supportbee: 'SupportBee',
      pipeline: 'Pipeline',
      zendesk: 'Zendesk',
      joget: 'Joget',
      firmao: 'Firmao',
      kylas: 'Kylas',
      close: 'Zatvori',
      firstpromoter: 'FirstPromoter',
      zingtree: 'Zingtree',
      liveagent: 'LiveAgent',
      ontraport: 'Ontraport',
      frontapp: 'FrontApp',
      webhoper: 'Webhoper',
      engagebay: 'EngageBay',
      helpshift: 'Helpshift',
      copper: 'Copper',
      autopilot: 'Autopilot',
      flowlu: 'Flowlu',
      freshdesk: 'Freshdesk',
      salesflare: 'Salesflare',
      teamgate: 'Teamgate',
      shipway: 'Shipway',
      googleSheets: 'Google Sheets',
      googleCalendar: 'Google Calendar',
      googleAnalytics: 'Google Analytics',
      supportTicketingSystem: 'Sustav za podršku putem karata',
      zapier: 'Zapier',
      pabbly: 'Pabbly',
      hubSpot: 'HubSpot',
      gitHub: 'GitHub',
      salesforce: 'Salesforce',
      inChatAudioAndVideoCall: 'Audio i video pozivi u razgovoru (Twilio/Agora)',
      courierTracking: 'Pracenje dostave',
      emailIntegration: 'Integracija e-pošte',
      webhooks: 'Webhooks',
      schedulers: 'Planeri',
      paymentGateways: 'Platni prolazi (Stripe & RazorPay)',
      enterpriseIntegrations: 'Integracije za poduzeće',
      customIntegration: 'Prilagođena integracija',
      shopifyIntegration: 'Shopify integracija',
      totalNumberOfMessages: 'Ukupan broj poruka',
      totalNumberOfLeads: 'Ukupan broj voditelja',
      weeklyReportBotwise: 'Tjedno izvješće, Botwise',
      averageAgentResponeTime: 'Prosječno vrijeme odgovora agenta',
      visitorTimingReport: 'Izvješt',
      customerSegmentBasedReports: 'Izvješća prema segmentima korisnika',
      tagBasedReports: 'Izvješća prema oznakama',
      leadGenerationReport: 'Izvješće o generiranju potencijalnih kupaca',
      supportOnWhatsApp: 'Podrška putem WhatsAppa',
      knowledgeBase: 'Baza znanja',
      onboardingAndTraining: 'Uvođenje i obuka',
      callAndEmailSupport: 'Podrška putem poziva i e-pošte',
      freeChatbotCreation: 'BESPLATNO stvaranje chatbota',
      customerSuccessOfficer: 'Službenik za uspjeh korisnika',
      secureConnection2048BitSSL: 'Sigurna veza 2048 bita SSL-a',
      securityAssessment: 'Procjena sigurnosti',
      dataCenterInUSOrEU: 'Podacište u SAD-u ili EU',
      twoStepVerification: 'Dvostupanjska verifikacija',
      accessRestrictionsBasedOnIPs: 'Ograničenja pristupa na temelju IP adresa',
      onDemandAuditLog: 'Audiotorij na zahtjev',
      bannedVisitorsList: 'Lista zabranjenih posjetitelja',
      customAPIRate: 'Prilagođena stopa API-ja',
      trustedDomains: 'Pouzdani domeni',
      mb100: '100 MB',
      gb1: '1 GB',
      codingCurious: 'Zainteresiran za programiranje',
    },
    appTooltip: {
      TOOLTIP_BABY_PLAN: 'Naš besplatni plan',
      TOOLTIP_KING_PLAN: 'Naš najpopularniji plan',
      TOOLTIP_EMPEROR_PLAN: 'Prilagođeni plan za neograničene poruke, neograničene podatke, neograničeni članovi tima',
      TOOLTIP_CONTACT_US: 'Dostupni smo putem WhatsAppa ili e-pošte na contact@botpenguin.com za više informacija o našem prilagođenom planu',
      TOOLTIP_UPGRADE: 'Nadogradite svoj trenutačni plan za dodatne značajke',
      TOOLTIP_MONTHLY: 'Odaberite mjesečni ciklus plaćanja',
      TOOLTIP_YEARLY: 'Odaberite godišnji ciklus plaćanja za pogodnosti popusta',
    }
  },
  whatsappPlans: {
    goToBabyPlan: 'Idi na Baby Plan',
    freeForever: 'BESPLATNO zauvijek',
    features: 'Značajke',
    currentPlan: 'Trenutni plan',
    changePlan: 'Promijeni plan',
    currentlyActive: 'Trenutačno aktivan',
    seeHowToUse: 'Pogledaj kako koristiti',
    weHaveGotPricingPerfectForYou: 'Imamo cjenovni plan koji je savršen za vas',
    weBelieve: 'Vjerujemo da ',
    shouldBeAccessibleToAllCompanies: 'treba biti dostupno svim tvrtkama, bez obzira na veličinu.',
    monthly: 'Mjesečno',
    yearly: 'Godišnje',
    twoMonthsFree: '(2 mjeseca BESPLATNO)',
    kingPlan: 'King Plan',
    perYear: 'godišnje',
    perMonth: 'mjesečno',
    conversationsPerMonth: 'Razgovori mjesečno',
    upgradePlan: 'Nadogradite plan',
    emperorPlan: 'Emperor Plan (Enterprise)',
    haveAsManyConversationsAsYouNeed: 'Imajte koliko god razgovora želite',
    contactUs: 'Kontaktirajte nas',
    metaConversationChargesAreAdditional: 'Naknade za meta-razgovore dodatne su i plaćaju se izravno od strane vas Meta, na temelju' +
      'vaše upotrebe. Mi ne naplaćujemo nikakve marže ili naknade za posredovanje.',
    viewDetailedPricing: 'Pogledajte detaljne cijene',
    conversationPricingModelUsedByMeta: 'Model cijena razgovora koji koristi Meta',
    whatsappBusinessPlatformConversationsFallInto: 'Razgovori putem WhatsApp Business Platforme podijeljeni su u dvije kategorije koje se cijene različito',
    userInitiatedConversation: 'Korisnički pokrenut razgovor',
    userInitiatedConversationDescription: 'Razgovor koji započinje kao odgovor na poruku korisnika. Kad god poslovni subjekt odgovori korisniku unutar' +
      '24-satnog prozora za korisničku podršku, ta će poruka biti povezana s korisnički pokrenutim razgovorom.' +
      'Poslovni subjekti mogu slati poruke slobodnog oblika unutar ovog 24-satnog prozora za korisničku podršku.',
    businessInitiatedConversation: 'Poslovno pokrenut razgovor',
    businessInitiatedConversationDescription: 'Razgovor koji započinje tako što poslovni subjekt šalje poruku korisniku izvan 24-satnog prozora' +
      'za korisničku podršku. Poruke koje pokreću razgovor pokrenut od strane poslovnog subjekta zahtijevat će predložak poruke.',
    areYouSureYouWantTo: 'Jeste li sigurni da želite prijeći s',
    conversations: ' Razgovori ',
    plan: ' plana',
    toThe: ' na',
    metaPricingMarkup: 'Meta Markup za cijene',
    numberOfChatFlows: 'Broj chat tokova',
    greenTickApplication: 'Primjena zelene kvačice',
    extraPhoneNumberLinking: 'Dodatno povezivanje brojeva telefona',
    teamMembers: 'Članovi tima',
    dataStorage: 'Pohrana podataka',
    conditionalFlow: 'Uvjetni tok',
    liveChat: 'Razgovor uživo',
    smartInbox: 'Pametni pristigla',
    whatsappTemplates: 'WhatsApp predlošci',
    customerSegments: 'Segmenti korisnika',
    broadcastAndDripCampaigns: 'Emitiranje i drip kampanje',
    multipleLanguages: 'Više jezika',
    bookAppointments: 'Rezervacija termina',
    csvContactsExport: 'Izvoz CSV kontakata',
    googleCalendarIntegrations: 'Integracije s Google kalendarom',
    nativeApplications: '60+ Nativnih integracija',
    whatsappSupport: 'WhatsApp podrška',
    emailAndCallSupport: 'Podrška putem e-pošte i poziva',
    customerIntegrations: 'Integracije s korisnicima',
    nlpAndNluCapabilities: 'Mogućnosti NLP-a i NLU-a',
    chatGPTBot: 'ChatGPT chatbot',
    customerSuccessOfficer: 'Službenik za uspjeh korisnika',
    noMarkupTransparency: 'Nema transparentnosti marže',
    upto500kPerMonth: 'Do 500,000 mjesečno',
    beyond500k: 'Iznad 500,000',
    unlimited: 'Neograničeno',
    unlimitedMessages: 'Neograničene poruke',
    oneTeamMember: '1 član tima',
    unlimitedTeamMember: 'Neograničeni članovi tima',
    nintyDaysOfDataStorage: '90 dana pohrane podataka',
    unlimitedDataStorage: 'Neograničena pohrana podataka',
    downgradeToFreePlan: 'Vrati se na BESPLATNI plan',
    detailedPricing: {
      onDemandAuditLog: 'Audit log na zahtjev',
      accessRestrictionsBasedOnIPs: 'Ograničenja pristupa temeljena na IP adresama',
      averageAgentResponeTime: 'Prosječno vrijeme odgovora agenta',
      perMonth100: '100 mjesečno',
      solutionType: 'Tip rješenja',
      saas: 'SaaS',
      saasOnPremises: 'SaaS Na Mjestu',
      emperorPlan: 'Plan Car',
      babyPlan: 'Plan Beba',
      kingsplan: 'Plan Kraljeva',
      braodcastsAndDrips: 'Emitiranje i kapanje',
      thirtyDays: '30 dana',
      ninetyDays: '90 dana',
      oneMember: '1 član',
      threeMembers: '3 člana',
      one: '1 (Jedan)',
      unlimitedMessages: 'Neograničene poruke',
      unlimitedBots: 'Neograničeni botovi',
      messagesSend: 'Poslane poruke',
      upto500000perMonth: 'Do 500,000 mjesečno',
      unlimited: 'Neograničeno',
      onlyAdmin: 'Samo administrator',
      mb100: '100 MB',
      gb1: '1 GB',
      doItYourself: 'Napravi sam',
      weAreHereToHelp: 'Tu smo da pomognemo',
      weTakeCareEndToEnd: 'Brinemo od početka do kraja',
      numberOfBots: 'Broj botova',
      conversations: 'Razgovori',
      gptMessages: 'GPT poruke',
      whatsappNumbers: 'WhatsApp brojevi',
      subscribersLeads: 'Pretplatnici/Leads',
      createSupportTeamForLiveChat: 'Stvaranje tima podrške za live chat',
      conversationHistory: 'Povijest razgovora',
      chatbotDesigning: 'Dizajniranje chatbota',
      multipleLanguages: 'Više jezika',
      conditionalFlow: 'Uvjetni tok',
      whatsappTemplates: 'WhatsApp predlošci',
      restartChatFlowTriggers: 'Ponovno pokretanje okidača za tok razgovora',
      multipleWhatsAppWidgets: 'Više WhatsApp widgeta',
      importWhatsappContacts: 'Uvoz Whatsapp kontakata',
      whatsappQuickReply: 'WhatsApp Brzi odgovor',
      whatsappSmartInbox: 'WhatsApp Pametna pristigla pošta',
      whatsappEcommerceCatalogs: 'WhatsApp e-trgovina s katalozima',
      whatsappBroadcast: 'WhatsApp Emitiranje',
      whatsappBroadcastAnalytics: 'WhatsApp Analitika emitiranja',
      dripCampaigns: 'Kapanje kampanje',
      customerSegmentation: 'Segmentacija kupaca',
      keywordBasedResponse: 'Odgovor na temelju ključnih riječi',
      whatsappShopManagement: 'Upravljanje trgovinom na WhatsAppu',
      aiChatbot: 'AI Chatbot',
      chatGPTIntegration: 'ChatGPT integracija',
      configureAIChatbotPersonality: 'Konfiguracija osobnosti AI Chatbota',
      trainChatbotOnYourOwnData: 'Obuka Chatbota na vlastitim podacima',
      trainChatbotOnWebPages: 'Obuka Chatbota na web stranicama',
      trainChatbotOnMultipleFiles: 'Obuka Chatbota na više datoteka',
      trainChatbotOnFAQs: 'Obuka Chatbota na FAQ-ovima',
      dataTrainingStorage: 'Pohrana podataka o obuci',
      useChatGPTModel4or35Turbo: 'Koristite ChatGPT Model 4/3.5 turbo',
      uploadMultipleFilesForChatbotTraining: 'Prijenos više datoteka za obuku chatbota',
      naturalLanguageProcessing: 'Obrada prirodnog jezika',
      naturalLanguageUnderstanding: 'Razumijevanje prirodnog jezika',
      answerLength: 'Duljina odgovora',
      chatTone: 'Tona razgovora',
      multiLanguage: 'Višejezično',
      answerFormatting: 'Oblikovanje odgovora',
      customPrompt: 'Prilagođeni nagovještaj',
      whatsAppSessionManagement: 'Upravljanje WhatsApp sesijom (Neaktivnost i ponovno pokretanje poruka)',
      integrateBotPenguinLLM: 'Integrirajte BotPenguin LLM',
      integrateOwnCustomLLM: 'Integrirajte vlastiti/prilagođeni LLM',
      periodicallySyncDataSources: 'Periodična sinkronizacija izvora podataka',
      aiBasedSuggestedQuestions: 'AI temeljena predložena pitanja',
      chooseVisibilityForParticularWebpageSitemap: 'Odaberite vidljivost za određenu web stranicu/sitemap',
      chooseKnowledgeMix: 'Odaberite mješavinu znanja: Vaša baza znanja ChatGPT znanje "ChatGPT znanje + Vaša baza znanja"',
      faqExtractionFromFileAndURL: 'Izvlačenje FAQ-a iz datoteke i URL-a',
      analyticsToImproveAI: 'Analitika za poboljšanje AI',
      exportQuestionFlow: 'Izvoz tijeka pitanja',
      collectFeedbackOnChatbotResponses: 'Prikupljanje povratnih informacija o odgovorima Chatbota',
      smartAIFollowUpQuestions: 'Pametna/AI pitanja za praćenje',
      trainOnYourNotionWorkspaceData: 'Obuka na podacima vašeg Notion radnog prostora',
      trainOnYoutubeVideo: 'Obuka na YouTube videu',
      trainOnCustomVideoUpload: 'Obuka na vlastitom videu',
      rssFeed: 'RSS Feed',
      googleDrive: 'Google Drive',
      dropBox: 'DropBox',
      humanHandover: 'Predaja čovjeku',
      botHandover: 'Predaja bota',
      handoverBetweenAgents: 'Predaja između agenata',
      emailAndMobileValidation: 'Potvrda e-pošte i mobilnog',
      mobileAppsForAgents: 'Mobilne aplikacije za agente',
      appointmentBooking: 'Rezervacija termina',
      roleBasedAccessControls: 'Kontrole pristupa temeljene na ulozi',
      ruleBasedChatRouting: 'Rule based Chat Routing',
      liveVisitorsDetails: 'Detalji o posjetiteljima uživo',
      multipleSimultaneousChats: 'Više istodobnih razgovora',
      visitorStats: 'Statistike posjetitelja',
      addContactsFromWhatsApp: 'Dodajte kontakte s WhatsAppa',
      applyFilterAndSortConversations: 'Primijenite filtar i sortirajte razgovore',
      seeChatLogs: 'Pogledajte zapise razgovora',
      quickReplies: 'Brzi odgovori',
      unifiedCustomerProfile: 'Jedinstveni profil kupca',
      assignNotesAndChatTags: 'Dodijelite bilješke i oznake razgovora',
      exportLeadsInCSV: 'Izvoz vodiča u CSV',
      tagContacts: 'Označi kontakte',
      customAttributes: 'Prilagođene značajke',
      markStatusOfConversations: 'Označi status razgovora',
      assignConversationToAgents: 'Dodijelite razgovor agentima',
      leadNotificationsByEmail: 'Obavijesti o vodičima e-poštom',
      directCallsToLeadsWithTwilio: 'Izravni pozivi vodičima (s Twiliom)',
      whatsAppTemplates: 'WhatsApp predlošci',
      promotionalMessageFrequencyControl: 'Kontrola frekvencije promotivnih poruka',
      whatsAppWidget: 'WhatsApp Widget',
      whatsAppQR: 'WhatsApp QR',
      whatsAppLink: 'WhatsApp Link',
      campaignScheduler: 'Planer kampanje',
      customTriggers: 'Prilagođeni okidači',
      customCampaigns: 'Prilagođene kampanje',
      repeatPurchaseReminders: 'Ponovni podsjetnici na kupnju',
      campaignOpenRateTracking: 'Pratitelj otvorenih kampanja',
      paymentCollectionOnWhatsApp: 'Prikupljanje plaćanja na WhatsAppu',
      agileCRM: 'Agile CRM',
      capsule: 'Kapsula',
      insightly: 'Insightly',
      nimble: 'Nimble',
      leadsquared: 'Leadsquared',
      chakra: 'Chakra',
      plivo: 'Plivo',
      helpcrunch: 'Helpcrunch',
      getresponse: 'Getresponse',
      supportbee: 'Supportbee',
      pipeline: 'Pipeline',
      zendesk: 'Zendesk',
      joget: 'Joget',
      firmao: 'Firmao',
      kylas: 'Kylas',
      close: 'Zatvori',
      firstpromoter: 'Firstpromoter',
      zingtree: 'Zingtree',
      liveagent: 'Liveagent',
      ontraport: 'Ontraport',
      frontapp: 'Frontapp',
      webhoper: 'Webhoper',
      engagebay: 'Engagebay',
      helpshift: 'Helpshift',
      copper: 'Copper',
      autopilot: 'Autopilot',
      flowlu: 'Flowlu',
      freshdesk: 'Freshdesk',
      salesflare: 'Salesflare',
      teamgate: 'Teamgate',
      shipway: 'Shipway',
      googleSheets: 'Google Sheets',
      googleCalendar: 'Google Calendar',
      googleAnalytics: 'Google Analytics',
      supportTicketingSystem: 'Sustav za podršku s ulaznicama',
      zapier: 'Zapier',
      pabbly: 'Pabbly',
      hubSpot: 'HubSpot',
      gitHub: 'GitHub',
      salesforce: 'Salesforce',
      inChatAudioAndVideoCall: 'Audio i video pozivi u chatu (Twilio/Agora)',
      courierTracking: 'Pratitelj kurira',
      emailIntegration: 'Integracija e-pošte',
      webhooks: 'Webhooks',
      schedulers: 'Planeri',
      paymentGateways: 'Platni prolazi (Stripe & RazorPay)',
      enterpriseIntegrations: 'Integracije poduzeća',
      customIntegration: 'Prilagođena integracija',
      freeWhatsAppAPIApprovalAndSetup: 'Besplatno odobrenje i postavljanje WhatsApp API-ja',
      developerAPIsAccess: 'Pristup programskim sučeljima razvojnog programera',
      customRateLimit: 'Prilagođeno ograničenje brzine',
      totalNumberOfLeads: 'Ukupan broj vodiča',
      averageAgentResponseTime: 'Prosječno vrijeme odgovora agenta',
      visitorTimingReport: 'Izvještaj o vremenu posjetitelja',
      customerSegmentBasedReports: 'Izvještaji temeljeni na segmentu kupaca',
      tagBasedReports: 'Izvještaji temeljeni na oznakama',
      leadGenerationReport: 'Izvještaj o generiranju vodiča',
      supportOnWhatsApp: 'Podrška na WhatsAppu',
      knowledgeBase: 'Baza znanja',
      onboardingAndTraining: 'Uvođenje i obuka',
      callAndEmailSupport: 'Podrška putem poziva i e-pošte',
      freeChatbotCreation: 'BESPLATNO stvaranje chatbota',
      customerSuccessOfficer: 'Službenik za uspjeh kupca',
      secureConnection: '2048-bitna SSL sigurna veza',
      securityAssessment: 'Procjena sigurnosti',
      dataCenterLocation: 'Lokacija podatkovnog centra u SAD-u ili EU',
      twoStepVerification: 'Verifikacija u dva koraka',
      accessRestrictions: 'Ograničenja pristupa',
      auditLog: 'Audit log na zahtjev',
      bannedVisitorsList: 'Popis zabranjenih posjetitelja',
      customAPIRate: 'Prilagođena stopa API-ja',
      trustedDomains: 'Pouzdane domene',
      elementary: 'Osnovno',
      bots: 'Botovi',
      unlockWhatsapp: 'Otključajte WhatsApp',
      aiChatbotFeatures: 'Značajke AI Chatbota',
      dataSourceForTraining: 'Izvor podataka za obuku',
      smartFeatures: 'Pametne značajke',
      liveChat: 'Razgovor uživo',
      smartInbox: 'Pametna pristigla pošta',
      broadcastsAndDrips: 'Emitiranja i kapanja',
      integrations: 'Integracije',
      development: 'Razvoj',
      reportsAndAnalytics: 'Izvještaji i analitika',
      customerSupport: 'Podrška kupcima',
      security: 'Sigurnost',
      whatsappWidgets: 'WhatsApp Widget',
      campaignSchedular: 'Planer kampanje',
      repeatPurchaseRemainder: 'Ponovni'
    },
    appTooltip: {
      TOOLTIP_BABY_PLAN: 'Naš besplatni plan',
      TOOLTIP_KING_PLAN: 'Naš najpopularniji plan',
      TOOLTIP_EMPEROR_PLAN: 'Prilagođeni plan za neograničene poruke, neograničene podatke, neograničene članove tima',
      TOOLTIP_CONTACT_US: 'Obratite nam se putem WhatsApp-a ili e-pošte na contact@botpenguin.com kako biste saznali više o našem prilagođenom planu',
      TOOLTIP_UPGRADE: 'Ažurirajte svoj trenutni plan za dodatne funkcije',
      TOOLTIP_MONTHLY: 'Odaberite mjesečni ciklus plaćanja',
      TOOLTIP_YEARLY: 'Odaberite godišnji ciklus plaćanja za pogodnosti popusta',
  }
  }
};
